export const SOURCE_ID = "tenants-source";
export const LAYER_GLOW_ID = "tenants-glow";
export const LAYER_CORE_ID = "tenants-core";

export const DEFAULT_COLOR = "#f9b233";
export const HOVERED_COLOR = "#00bcd4";
export const DEFAULT_GLOW = "rgba(255,140,0,0.25)";
export const HOVERED_GLOW = "rgba(0,188,212,0.25)";

export const REGION_LONGITUDE_BOUNDARY = -30;

export const US_CENTER: [number, number] = [-95, 38];
export const EU_CENTER: [number, number] = [15, 50];
export const US_ZOOM = 3.5;
export const EU_ZOOM = 0.5;
